import { Component, output, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { PropertyFeatures } from "../../../models/propertyFeatures";

@Component({
  standalone: false,
  selector: 'app-property-features-filter',
  templateUrl: './property-features-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./property-features-filter.component.scss']
})
export class PropertyFeaturesFilterComponent {
  readonly onPropertyFeaturesSelectionChange = output<PropertyFeatures | undefined>();

  public selectedPropertyFeatures: PropertyFeatures | undefined;
  public propertyFeaturesForm: FormGroup;

  public bedRoomFilterValues: { label: string, value: number|undefined }[] = [{ label: "Any", value: undefined }, { label: "1+ Beds", value: 1 }, { label: "2+ Beds", value: 2 }, { label: "3+ Beds", value: 3 }, { label: "4+ Beds", value: 4 }];
  public bathRoomFilterValues: { label: string, value: number|undefined }[] = [{ label: "Any", value: undefined }, { label: "1+ Baths", value: 1 }, { label: "2+ Baths", value: 2 }, { label: "3+ Baths", value: 3 }, { label: "4+ Baths", value: 4 }];
  public garageFilterValues: { label: string, value: number|undefined }[] = [{ label: "Any", value: undefined }, { label: "1+ Cars", value: 1 }, { label: "2+ Cars", value: 2 }, { label: "3+ Cars", value: 3 }, { label: "4+ Cars", value: 4 }];

  constructor(){
    this.propertyFeaturesForm = new FormGroup({
      beds: new FormControl<{ label: string, value: number|undefined }>(this.bedRoomFilterValues[0]),
      baths: new FormControl<{ label: string, value: number|undefined }>(this.bathRoomFilterValues[0]),
      garages: new FormControl<{ label: string, value: number|undefined }>(this.garageFilterValues[0]),
      areaFrom: new FormControl<number|undefined>(undefined),
      areaTo: new FormControl<number|undefined>(undefined)
    });
  }

  public presetSelectedPropertyFeatures(pf: PropertyFeatures | undefined) {
    this.selectedPropertyFeatures = pf;
    this.resetFormFromCommitted();
  }

  get propertyFeatureSelected(): boolean {
    return this.selectedPropertyFeatures?.definedFeatures? true : false;
  }

  get menuLabel(): string {
    let label = "Property Features";
    if (this.propertyFeatureSelected) label += ` (${this.selectedPropertyFeatures?.definedFeatures})`;
    return label;
  }

  private resetFormFromCommitted() {
    this.propertyFeaturesForm.get('beds')!.setValue(this.selectedPropertyFeatures?.beds ? this.bedRoomFilterValues.find(v => v.value == this.selectedPropertyFeatures?.beds) : this.bedRoomFilterValues[0]);
    this.propertyFeaturesForm.get('baths')!.setValue(this.selectedPropertyFeatures?.baths ? this.bathRoomFilterValues.find(v => v.value == this.selectedPropertyFeatures?.baths) : this.bathRoomFilterValues[0]);
    this.propertyFeaturesForm.get('garages')!.setValue(this.selectedPropertyFeatures?.garages ? this.garageFilterValues.find(v => v.value == this.selectedPropertyFeatures?.garages) : this.garageFilterValues[0]);
    this.propertyFeaturesForm.get('areaFrom')!.setValue(this.selectedPropertyFeatures?.areaFrom);
    this.propertyFeaturesForm.get('areaTo')!.setValue(this.selectedPropertyFeatures?.areaTo);
  }

  /** Fires with the reason the menu closed: falsy = dismissed via outside click -> discard staged form changes. */
  public onMenuClosed(reason: any) {
    if (!reason) this.resetFormFromCommitted();
  }

  public onApplyClick() {
    const pf = new PropertyFeatures();
    pf.beds = this.propertyFeaturesForm.get('beds')!.value?.value;
    pf.baths = this.propertyFeaturesForm.get('baths')!.value?.value;
    pf.garages = this.propertyFeaturesForm.get('garages')!.value?.value;
    pf.areaFrom = this.propertyFeaturesForm.get('areaFrom')!.value;
    pf.areaTo = this.propertyFeaturesForm.get('areaTo')!.value;

    this.selectedPropertyFeatures = pf;
    this.onPropertyFeaturesSelectionChange.emit(this.selectedPropertyFeatures);
  }

  public onClearClick() {
    this.selectedPropertyFeatures = undefined;
    this.resetFormFromCommitted();
    this.onPropertyFeaturesSelectionChange.emit(undefined);
  }
}